export default {
  toasts: {
    load_error: 'Laden van de betaalinstellingen mislukt',
    rails_saved: 'Betaalkanalen opgeslagen',
    gateway_registered: 'Gateway geregistreerd',
    redact_failed: 'Gateway redigeren mislukt',
    gateway_redacted: 'Gateway geredigeerd',
    sca_provisioned: '3DS2-registratie aangemaakt',
    company_assigned: 'Restaurant toegewezen',
    default_set: 'Standaardgateway ingesteld — nieuwe restaurants worden er automatisch aan toegewezen',
    default_failed: 'Instellen van de standaardgateway mislukt',
    primary_switched: 'Primaire gateway gewijzigd naar {{gateway}}',
    primary_switch_failed: 'Wisselen van primaire gateway mislukt',
  },
  custody: {
    title: 'Wie verwerkt betalingen',
    description:
      'Eenmalig bepaald, bij het opslaan van de eerste rail, en daarna vergrendeld: met een eigen gateway beheert de partner de gelden zelf; op de FoodAmigos Adyen-account beheert FoodAmigos ze en betaalt het aandeel van de partner maandelijks uit.',
    options: {
      provider: 'Eigen gateway van de partner',
      platform: 'FoodAmigos verwerkt betalingen',
    },
    locked_notice: 'Vergrendeld op “{{custodian}}” door de betalingsconfiguratie — kan niet worden gewijzigd.',
    pick_first: 'Kies eerst wie betalingen verwerkt.',
    lock_confirm: {
      title: 'Betalingen vergrendelen voor “{{custodian}}”?',
      description:
        'Als u nu opslaat, wordt bepaald wie de gelden van deze partner beheert, en dat kan niet ongedaan worden gemaakt — niet hier, en niet door support. De betaalmethode kan later nog worden gewijzigd; wie de betalingen verwerkt niet.',
      confirm: 'Vergrendelen en opslaan',
    },
  },
  rails: {
    title: 'Betaalkanaal',
    description:
      'Welke verwerker deze partner gebruikt — één tegelijk. Restaurants kunnen alleen overschakelen naar het hier gekozen kanaal, en een kanaal kan niet worden vervangen zolang restaurants er nog op afrekenen.',
    save: 'Kanaal opslaan',
    multiple_warning:
      'Deze partner gebruikt nog meer dan één kanaal ({{rails}}). Opslaan behoudt alleen het hierboven geselecteerde; de rest wordt verwijderd, en de wijziging wordt geweigerd als een restaurant nog op een van die kanalen afrekent.',
    options: {
      stripe: 'Stripe',
      adyen: 'Adyen',
      spreedly: 'Lokale gateway via Spreedly',
    },
    platform_stripe_unavailable: 'Stripe op de FoodAmigos-accounts is nog niet beschikbaar.',
    platform_custody_notice: 'Niet beschikbaar wanneer FoodAmigos de betalingen verwerkt.',
    provider_custody_adyen_notice:
      'Niet beschikbaar wanneer de partner zijn eigen gateway meebrengt — Adyen is het FoodAmigos-verwerkingskanaal.',
  },
  spreedly_section_title: 'Spreedly-instellingen',
  gateways: {
    title: 'Gateways',
    description:
      'De eigen PSP-accounts van de partner. De volledige afschrijving wordt uitbetaald aan de acquirer van de gekozen gateway.',
    register: 'Gateway registreren',
    empty: 'Nog geen gateways geregistreerd',
    columns: {
      gateway: 'Gateway',
      status: 'Status',
      sca: '3DS2',
      companies: 'Restaurants',
    },
    statuses: {
      active: 'Actief',
      redacted: 'Geredigeerd',
    },
    sca: {
      sandbox: '3DS2-sandbox',
      live: '3DS2-live',
      none: 'Geen 3DS2',
    },
    default_tag: 'Standaard',
    actions: {
      make_default: 'Als standaard instellen',
      check: 'Controle uitvoeren…',
      sca_provision: '3DS2 instellen…',
      sca_manage: '3DS2-registratie…',
      redact: 'Gateway redigeren',
    },
  },
  redact_confirm: {
    title: '{{gateway}} redigeren?',
    description:
      'De inloggegevens worden bij Spreedly verwijderd en kunnen niet worden hersteld. {{count}} toegewezen restaurant(s) rekenen nog via deze gateway af — zolang er nog restaurants toegewezen zijn, wordt de redactie geweigerd en wordt om een tweede bevestiging gevraagd.',
    redact: 'Redigeren',
    force_title: '{{gateway}} toch redigeren?',
    force_description:
      '{{count}} restaurant(s) zijn nog aan deze gateway toegewezen. Als u deze nu redigeert, wordt hun afrekenen geweigerd totdat elk een andere gateway krijgt toegewezen. Dit kan niet ongedaan worden gemaakt.',
    force_redact: 'Toch redigeren',
  },
  companies: {
    title: 'Restaurants',
    description: 'Via welke verwerker elk restaurant afrekent, en de bijbehorende Spreedly-gatewaytoewijzing.',
    empty: 'Geen restaurants',
    no_gateway: 'Geen',
    unassigned: 'Niet toegewezen',
    // The default gateway is assigned at creation and never fails the creation —
    // so a restaurant can end up unassigned with the reason only in the log.
    assignment_error_label: 'Automatische toewijzing mislukt',
    assign: 'Toewijzen',
    reassign: 'Opnieuw toewijzen',
    columns: {
      restaurant: 'Restaurant',
      primary_gateway: 'Primaire gateway',
      spreedly: 'Spreedly-gateway',
    },
    switch_primary_to: 'Overschakelen naar {{gateway}}',
    assign_modal: {
      title: '{{company}} toewijzen aan een gateway',
      assign: 'Toewijzen',
      gateway: 'Gateway',
      make_primary: 'Spreedly ook als primaire gateway instellen',
      make_primary_hint: 'Afschrijvingen lopen alleen via Spreedly zolang het de primaire gateway is.',
    },
  },
  register_modal: {
    title: 'Een gateway registreren',
    register: 'Registreren',
    gateway_type: 'Gatewaytype',
    gateway_type_placeholder: 'Zoek in de catalogus van Spreedly…',
    auth_mode: 'Authenticatiemodus',
    no_credentials: 'Dit gatewaytype vereist geen inloggegevens (Spreedly-sandbox).',
    description: 'Omschrijving',
    description_placeholder: 'bijv. Acme Eats — Braintree EUR',
    acquirer_merchant_id: 'Acquirer merchant-ID',
    acquirer_hint: 'Optioneel — vereist samen met MCC',
    mcc: 'MCC',
    mcc_hint: '4 cijfers, bijv. 5812',
    make_default: 'Gebruiken als standaard van de partner',
    make_default_hint:
      'De nieuwe restaurants van de partner en de restaurants zonder gateway worden eraan gekoppeld. Laat dit uitgevinkt als het de eigen acquirer van één restaurant is.',
  },
  sca_modal: {
    title: '3DS2-registratie — {{gateway}}',
    provision: 'Inrichten',
    irreversible_warning:
      'Onomkeerbaar: noch het handelaarsprofiel noch de SCA-provider kan achteraf worden bewerkt of verwijderd. Een onjuiste acquirer-BIN komt pas aan het licht bij een afschrijving. Controleer elke waarde bij de acquirerbank vóór het inrichten.',
    already_provisioned:
      'Al ingericht (providertoken {{token}}). Opnieuw inrichten geeft de bestaande registratie terug, tenzij Opnieuw aanmaken is ingeschakeld.',
    type: {
      label: 'Providertype',
      hint: '“Test” simuleert authenticatie-uitkomsten en wordt in productie geweigerd.',
      test: 'Test (SCA-sandbox)',
      live: 'Live (Spreedly 3DS2 Global)',
    },
    country: {
      hint: 'Het land waaronder de acquiring bank deze handelaar heeft geregistreerd — niet per se waar de partner is gevestigd. Geldt voor elk kaartnetwerk hieronder.',
      differs_warning:
        'Dit is niet het land van de partner ({{country}}). Corrigeer dit als de acquirer de handelaar elders heeft geregistreerd; controleer het anders goed, want een handelaarsprofiel kan na aanmaak niet meer worden bewerkt.',
    },
    network_placeholder: 'Kaartnetwerk',
    add_network: 'Kaartnetwerk toevoegen',
    networks: {
      visa: 'Visa',
      mastercard: 'Mastercard',
      amex: 'American Express',
      discover: 'Discover',
      diners: 'Diners',
      jcb: 'JCB',
      dankort: 'Dankort',
      union_pay: 'UnionPay',
      cartes_bancaires: 'Cartes Bancaires',
    },
    fields: {
      acquirer_merchant_id: 'Acquirer merchant-ID',
      acquirer_bin: 'Acquirer-BIN',
      mcc: 'MCC',
      merchant_name: 'Handelsnaam',
      country_code: 'Land (ISO-2)',
      merchant_url: 'URL van handelaar',
    },
    recreate: {
      label: 'Registratie opnieuw aanmaken',
      hint: 'Verwijdert het huidige handelaarsprofiel en de SCA-provider definitief en maakt nieuwe aan.',
    },
  },
  check_modal: {
    title: 'Gateway controleren — {{gateway}}',
    run: 'Controle uitvoeren',
    done: 'Klaar',
    failed: 'De controle kon niet worden uitgevoerd.',
    types: {
      verify: 'Verifiëren (geen geldtransactie)',
      test_payment: 'Testbetaling',
    },
    verify_unsupported: 'Dit type gateway ondersteunt geen verificatie — voer in plaats daarvan een testbetaling uit.',
    test_payment_warning:
      'Er wordt een echte transactie uitgevoerd op een live gateway en direct terugbetaald. Bij gateways in SCA-markten kan de uitgever de niet-3DS-test weigeren — dat bewijst nog steeds dat de gegevens de acquirer hebben bereikt.',
    amount: 'Bedrag',
    amount_help: 'Tussen 1,00 en 5,00',
    check_passed: 'Controle geslaagd',
    check_failed: 'Controle mislukt — zie de stappen hieronder',
    legs: {
      verify: 'Verificatie',
      purchase: 'Betaling',
      credit: 'Terugbetaling',
    },
    leg_passed: 'Geslaagd',
    leg_failed: 'Mislukt',
  },
  card_fields: {
    script_failed: 'Het Spreedly-script kon niet worden geladen. Controleer het netwerk en probeer het opnieuw.',
    full_name: 'Naam kaarthouder',
    number: 'Kaartnummer',
    expiry: 'Vervaldatum',
    cvv: 'CVV',
  },
};
